// extracted by mini-css-extract-plugin
export default {"button":"components-Filter-themes-BGH-filterButton__button--loZ3L"};